import {useEffect, useState, useCallback} from "react";
import {Modal, Table} from "antd";
import StatusLabel from "~/components/StatusLabel";
import {reportApi} from "~/api";
import {apiError, handleRequest, numberFormat} from "~/utils";

const CONTACT_STATUS = {0: 'Chưa gọi', 1: 'Đã gọi', 2: 'Đã hẹn'};
const EVENT_POINT = {0: 'Đợi đi', 1: 'Đang gặp', 2: 'Hoàn thành', 3: 'Đã hủy'};

//Render tag dịch vụ / loại ký dạng object {label, badge}
const renderTag = (v) => (v?.label ? <StatusLabel small type={v.badge}>{v.label}</StatusLabel> : <span className="color-gray">—</span>);

//Cấu hình cột theo từng loại chỉ số
const COLUMN_CONFIG = {
	sources: [
		{title: 'Tên', dataIndex: 'name'},
		{title: 'SĐT', dataIndex: 'phone', width: 130},
		{title: 'Trạng thái', dataIndex: 'status', width: 110, render: (v) => CONTACT_STATUS[v] || '—'},
		{title: 'Ngày tạo', dataIndex: 'date', width: 160},
	],
	calls: [
		{title: 'Tên', dataIndex: 'name'},
		{title: 'SĐT', dataIndex: 'phone', width: 130},
		{title: 'Thời gian gọi', dataIndex: 'date', width: 160},
	],
	appointments: [
		{title: 'Khách hàng', dataIndex: 'name'},
		{title: 'SĐT', dataIndex: 'phone', width: 130},
		{title: 'Thời gian hẹn', dataIndex: 'date', width: 150},
		{title: 'Trạng thái', dataIndex: 'point', width: 120, render: (v) => EVENT_POINT[v] || '—'},
	],
	consultations: [
		{title: 'Khách hàng', dataIndex: 'name'},
		{title: 'SĐT', dataIndex: 'phone', width: 130},
		{title: 'Thời gian tư vấn', dataIndex: 'date', width: 150},
		{title: 'Hình thức', dataIndex: 'shared', width: 140, render: (v) => v ? 'Đi chung (tính 0.5)' : 'Đi 1 mình (tính 1)'},
	],
	contracts: [
		{title: 'Mã HĐ', dataIndex: 'code', width: 120},
		{title: 'Tên hợp đồng', dataIndex: 'name'},
		{title: 'Mã KH', dataIndex: 'customerId', width: 90, render: (v) => (v ? `KH${v}` : '—')},
		{title: 'Dịch vụ', dataIndex: 'service', width: 110, render: renderTag},
		{title: 'Loại ký', dataIndex: 'serviceType', width: 120, render: renderTag},
		{title: 'Giá trị', dataIndex: 'price', width: 130, align: 'right', render: (v) => `${numberFormat(v)} đ`},
		{title: 'Ngày ký', dataIndex: 'date', width: 110},
		{title: 'Hình thức', dataIndex: 'shared', width: 130, render: (v) => v ? 'Share (tính 0.5)' : 'Riêng (tính 1)'},
	],
	revenue: [
		{title: 'Mã HĐ', dataIndex: 'contractId', width: 110, render: (v) => (v ? `HĐ #${v}` : '—')},
		{title: 'Dịch vụ', dataIndex: 'service', width: 110, render: renderTag},
		{title: 'Loại ký', dataIndex: 'serviceType', width: 120, render: renderTag},
		{title: 'Số tiền', dataIndex: 'price', width: 130, align: 'right', render: (v) => `${numberFormat(v)} đ`},
		{title: 'Ngày', dataIndex: 'date', width: 110},
	],
};

function StaffSummaryDetailModal({open, onClose, detail, time}) {

	const [loading, setLoading] = useState(false);
	const [rows, setRows] = useState([]);

	const {userId, userName, type, typeLabel} = detail || {};

	const load = useCallback(async () => {
		if(!open || !userId || !type) return;
		setLoading(true);
		setRows([]);
		const [error, response] = await handleRequest(reportApi.saleStaffSummaryDetail({userId, type, time}));
		const message = apiError('Lấy chi tiết thất bại', error, response);
		if(!message) setRows(response.data?.rows || []);
		setLoading(false);
	}, [open, userId, type, time]);

	useEffect(() => { load().then(); }, [load]);

	const columns = (COLUMN_CONFIG[type] || []).map((c, i) => ({...c, key: c.dataIndex || i}));

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={null}
			width={860}
			title={`${typeLabel || 'Chi tiết'} — ${userName || ''} (${rows.length})`}
		>
			<Table
				columns={columns}
				dataSource={rows}
				rowKey={(_, i) => i}
				loading={loading}
				size="small"
				scroll={{x: 'max-content', y: 460}}
				pagination={rows.length > 20 ? {pageSize: 20} : false}
				locale={{emptyText: 'Không có dữ liệu'}}
			/>
		</Modal>
	)
}

export default StaffSummaryDetailModal;
